import React from 'react';
import type Developer from '@/types/api/Developer';
import MetaContentType from '../constants/MetaContentType';
import EntityDetailsMetaContent from './EntityDetailsMetaContent';

type EntityDetailsFooterProps = {
  children: React.ReactNode;
  created?: string;
  createdBy?: Developer;
  updated?: string;
  updatedBy?: Developer;
};

export default function EntityDetailsFooter({
  children,
  created,
  createdBy,
  updated,
  updatedBy,
}: EntityDetailsFooterProps) {
  return (
    <div className="flex items-start border-t border-grey-300 pt-1">
      <div className="mr-auto mt-3 text-text-secondary type-caption1">
        {created && (
          <EntityDetailsMetaContent
            date={created}
            user={createdBy}
            type={MetaContentType.ADDED_BY}
          />
        )}
        {updated && created !== updated && (
          <EntityDetailsMetaContent
            date={updated}
            user={updatedBy}
            type={MetaContentType.UPDATED_BY}
          />
        )}
      </div>
      {children}
    </div>
  );
}
